<template>

    <div>
        <div class="bg-light p-4 mb-4">
            <div class="mb-4">
                <img :src="supplier.logo" alt="" class="img-fluid" v-if='supplier.logo' loading="lazy" style="min-width: 100%;" />
            </div>
            <div class="mt-3 d-grid gap-3">
                <a :href="supplier.terms_url" class="btn btn-lg btn-outline-primary" target="_blank" v-if="supplier.terms_url">
                    {{ __('AGB des Lieferanten') }}
                </a>
                <a :href="'mailto:' + supplier.contact_email" class="btn btn-lg btn-outline-secondary" v-if="supplier.contact_email">
                    {{ __('Nachricht an Lieferant') }}
                </a>
                <a :href="supplier.website" class="btn btn-lg btn-outline-secondary" target="_blank" v-if="supplier.website">
                    {{ __('Lieferanten-Website aufrufen') }}
                </a>
            </div>
            <div class="mt-3">
                <dl>
                    <dt>{{ __('Kontakt') }}</dt>
                    <dd>
                        <div v-if="supplier.phone">
                            {{ __('Tel: ') }} {{ supplier.phone }}
                        </div>
                        <div v-if="supplier.fax">
                            {{ __('Fax: ') }} {{ supplier.fax }}
                        </div>
                        <div v-if="supplier.contact_email">
                            {{ __('E-Mail: ') }} <a :href="'mailto:' + supplier.contact_email">{{ supplier.contact_email }}</a>
                        </div>
                    </dd>
                    <dt>{{ __('Adresse') }}</dt>
                    <dd v-html="supplier.formatted_address" v-if="supplier.formatted_address">
                    </dd>
                    <dd>
                        <div v-if="supplier.vat_id">
                            {{ __('USt.-ID: ') }} {{ supplier.vat_id }}
                        </div>
                        <div v-if="supplier.register_number">
                            {{ supplier.register_number }}
                        </div>
                    </dd>
                </dl>
            </div>
        </div>

        <template v-if="isFavoriteSupplier">
            <inertia-link :href="route('suppliers.remove-from-favorites', supplier)" as="button" method="delete" class="btn btn-primary w-100 text-white">
                <i class="bi bi-pin-angle"></i>
                <div class="mt-2">
                    {{ __('Aus Favoriten entfernen') }}
                </div>
            </inertia-link>
        </template>
        <template v-else>
            <inertia-link :href="route('suppliers.add-to-favorites', supplier)" as="button" method="post" class="btn btn-outline-primary w-100">
                <i class="bi bi-pin-angle"></i>
                <div class="mt-2">
                    {{ __('Zu Favoriten hinzufügen') }}
                </div>
            </inertia-link>
        </template>
    </div>

</template>

<script>
    export default {
        props: [
            'supplier',
            'isFavoriteSupplier',
        ],
        components: {

        }
    }
</script>